import s from '../style/chat.module.scss';
import { Chat, queryAgentList } from '@/chatBI';
import { useState, useRef } from 'react';
const ChatBI = (props) => {
    const [study, setstudy] = useState(
        'eyJhbGciOiJIUzUxMiJ9.eyJ0b2tlbl91c2VyX2VtYWlsIjoiYWRtaW5AeHguY29tIiwidG9rZW5fdXNlcl9pZCI6MSwidG9rZW5fdXNlcl9kaXNwbGF5X25hbWUiOiJhZG1pbiIsInRva2VuX2NyZWF0ZV90aW1lIjoxNzUwMTIxMDU4OTkxLCJ0b2tlbl9pc19hZG1pbiI6MSwidG9rZW5fdXNlcl9uYW1lIjoiYWRtaW4iLCJ0b2tlbl91c2VyX3Bhc3N3b3JkIjoiYzNWd1pYSnpiMjVwWTBCaWFXTnZiZGt0SkpZV3c2QTNyRW1CVVB6Ym4vNkROZVluRCt5M21Bd0RLRU1TM0tWVCIsInN1YiI6ImFkbWluIiwiZXhwIjo0OTIyODk5MjAwfQ.fmMgaTWcXyxn4Sat5k0axoSOVs9SthMTcnRzRbIwV__1R1re5ZSvcHSKFbXrBfWnBv3ykoGIhZGh9K5L5tDOUQ'
    );
    const conversationRef = useRef();
    const {
        sessionId,
        curSkill,
        agentId,
        currentSessionMapIdRef,
        currentSessionMapIdList,
        linkToSession,
        formatSessionList,
        sessionListRef,
        goLogin,
        currentAgent,
        userid,
        isCanSendMsg,
        checkIsLogin,

        chatBIRef
    } = props;

    return (
        <>
            <div className={s['chats-box']}>
                <div
                    style={{
                        flex: 1,
                        maxWidth: '1100px',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Chat
                        token={study}
                        initialAgentId={16}
                        key={`chat-${16}`}
                        ref={(node) => {
                            conversationRef.current = node;
                            chatBIRef.current = node;
                        }}
                        agentId={agentId}
                        skillId={curSkill?.ability_id}
                        currentSessionMapIdRef={currentSessionMapIdRef}
                        currentSessionMapIdList={currentSessionMapIdList}
                        linkToSession={linkToSession}
                        formatSessionList={formatSessionList}
                        sessionListRef={sessionListRef}
                        externalSessionId={sessionId}
                        curSkill={curSkill}
                        goLogin={goLogin}
                        currentAgenticon={currentAgent}
                        userid={userid}
                        isCanSendMsg={isCanSendMsg}
                        checkIsLogin={checkIsLogin}
                    />
                </div>
            </div>
        </>
    );
};
export default ChatBI;
